import React from "react";
import { GrGithub } from "react-icons/gr";
import { AiFillLinkedin } from "react-icons/ai";
import { MdOutlineFacebook } from "react-icons/md";
import { GoMail } from "react-icons/go";
import { BsArrowRight } from "react-icons/bs";
import me from "../assets/images/me.jpg";
import Typed from "react-typed";

const Details = () => {
  return (
    <div class="card lg:sticky lg:top-28 lg:ml-[-36px] lg:w-96 w-full shadow-2xl text-base-100 bg-primary rounded-lg lg:mt-[-5em] ">
      <div class="avatar mx-auto mt-7">
        <div class="lg:w-40 lg:w-52 w-48 rounded-full">
          <img src={me} />
        </div>
      </div>
      <div class="card-body items-center text-center">
        <h2 className="card-title">Md Kibria hossain</h2>
        <Typed
          className="text-accent"
          strings={["Front End Developer"]}
          typeSpeed={180}
        />
        <div className="flex border-y-2 items-center justify-center border-dotted border-accent py-5 w-full mt-10">
          <span title="Facebook" className="text-2xl s_link lg:px-5 px-2 ">
            <a
              target={"_blank"}
              href="https://www.facebook.com/kibria.hossain.503"
            >
              <MdOutlineFacebook />
            </a>
          </span>
          <span title="LinkedIn" className="text-2xl s_link lg:px-5 px-2 ">
            <a
              target={"_blank"}
              href="https://www.linkedin.com/in/md-kibriahossain"
            >
              <AiFillLinkedin />
            </a>
          </span>
          <span title="Github" className="text-2xl s_link lg:px-5 px-2 ">
            <a target={"_blank"} href="https://github.com/Kibria934">
              <GrGithub />
            </a>
          </span>
          <span title="Mail" className="text-2xl s_link lg:px-5 px-2 ">
            <GoMail />
          </span>
        </div>
        <div class="">
          <a href="#contact">
            <button class="btn btn-secondary my-8  btn-outline">
              Contact Me
              <span className=" ml-2 text-xl">
                <BsArrowRight />
              </span>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Details;
